import { render } from "./DetailsCard.vue?vue&type=template&id=f7f96eb0&scoped=true&ts=true"
import script from "./DetailsCard.vue?vue&type=script&lang=ts"
export * from "./DetailsCard.vue?vue&type=script&lang=ts"

import "./DetailsCard.vue?vue&type=style&index=0&id=f7f96eb0&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2602801780/src/biomass-frontend-poc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7f96eb0"]])

export default __exports__